var $264cd81c52b30815$exports = {};
$264cd81c52b30815$exports = {
    "alpha": `Alfa`,
    "blue": `Plava`,
    "brightness": `Osvetljenost`,
    "green": `Zelena`,
    "hue": `Nijansa`,
    "lightness": `Osvetljenje`,
    "red": `Crvena`,
    "saturation": `Zasi\u{107}enje`
};


export {$264cd81c52b30815$exports as default};
//# sourceMappingURL=sr-SP.module.js.map
